import { Column } from "@tanstack/react-table";
import { DebouncedInput } from "./debouncedInput";

type Props<TData> = {
    column: Column<TData>;
};

export const ColumnFilter = <TData,>({ column }: Props<TData>) => {
    const columnFilterValue = column.getFilterValue();
    const { filterVariant } = (column.columnDef.meta as { filterVariant?: string }) ?? {};

    return filterVariant === "range" ? (
        <div>
            <DebouncedInput
                type="number"
                value={(columnFilterValue as [string, string])?.[0] ?? ""}
                onChange={value => column.setFilterValue((old: [string, string]) => [value, old?.[1]])}
                placeholder="Min"
            />
            <DebouncedInput
                type="number"
                value={(columnFilterValue as [string, string])?.[1] ?? ""}
                onChange={value => column.setFilterValue((old: [string, string]) => [old?.[0], value])}
                placeholder="Max"
            />
        </div>
    ) : (
        <DebouncedInput
            onChange={value => column.setFilterValue(value)}
            placeholder="Filter"
            type="text"
            value={(columnFilterValue ?? "") as string}
        />
    );
};
